import axios from 'axios';
import API from '../endpoints';
import { useQuery } from '@tanstack/react-query';
import { Team } from '@repo/types';

export const useTeamBySlugQuery = (slug: string | undefined) => {
  return useQuery({
    queryKey: ['team', { slug: slug! }],
    queryFn: async () => {
      const { data } = await axios.get<Team | null>(`${API.endpoints.teams}/${slug}`);
      return data;
    },
    enabled: !!slug,
  });
};

export const fetchTeamBySlug = async (slug: string): Promise<Team | null> => {
  const { data } = await axios.get<Team | null>(`${API.endpoints.teams}/${slug}`);
  return data;
};
